<template>
    <!--End category switcher-->
    <div>
        <ul class="categories">
            <li v-for="(category, index) in productCategories" v-bind:class="{active: category.slug === $route.params.productSlug || (justLoaded && index === 0)}">
                <router-link :to="urlPrefix + category.slug">
                    <input class="radio" type="radio" :value="0"><span class="filter__section-checkbox"></span>
                    <span class="filter-icon filter-icon--custom" v-html="category.icon"></span>
                    {{category.menu_label}}
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
import helpers from './../../helpers'
export default {

    data: function() {
        return {
            helpers: helpers,
            // slug: this.specialFilterSlug
        }
    },
    props: {
        'productCategories': {required: true},
    },
    computed: {
        urlPrefix: function() {
            return '/' + helpers.getLocale() + '/';
        },
        justLoaded: function(){
            return (this.$route.params.productSlug === undefined);
        }
    }
}
</script>
<style lang="scss" scoped>

.active .filter__section-checkbox{
    background: #009DFF;
}
.night .active .filter__section-checkbox{
    background: white;
}

.filter__section-checkbox{
    top: 50%;
    left: 0;
    transform: translateY(-50%) translateY(-1px);
}

.filters ul li a:hover{
    background: white;
    color:black;
}

.filters ul li a .filter-icon, .filters ul li button .filter-icon {
    margin-left: 10px;
}
.categories{
    margin-bottom: 30px;

    @media screen and (max-width: 767px){
        margin-top: -15px!important;
        margin-bottom: 25px;
    }

    li {
        & .filter-icon {
            width: 40px;
            text-align: center;
        }
    }
    .radio{
        display: none;
    }
}

.active{
    background-color: #000000;
    color: #ffffff;
}

.filter-icon svg{
    height: 50px;
}

</style>



// WEBPACK FOOTER //
// resources/assets/js/site/components/bhf-filter/bhf-category-switcher.vue